import "./FighterItem.less";
import {useRef} from "preact/hooks";
import {TexturedShopItem, TexuredShopItemProps} from "@game/ui/components/Shop/TexturedShopItem";

export const FighterItem = ({
    textureUrl = "",
    playerColor = undefined,
    className = ""
}: TexuredShopItemProps) => {
    const texturedItem = useRef<HTMLDivElement>(null);

    return (
        <div className={"shop-item-fighter"}>
            <div ref={texturedItem} className={"shop-item-fighter__cell"}>
                <TexturedShopItem
                    className={className}
                    textureUrl={textureUrl}
                    playerColor={playerColor}
                />
            </div>
            <div className={"shop-item-fighter__cell"}>
                <div className={"shop-item-fighter__cell"}>
                    <TexturedShopItem
                        className={className}
                        textureUrl={textureUrl}
                        playerColor={playerColor}
                    />
                </div>
                <div className={"shop-item-fighter__cell"}>
                    <TexturedShopItem
                        className={className}
                        textureUrl={textureUrl}
                        playerColor={playerColor}
                    />
                </div>
            </div>
        </div>
    );
};
